import {
  getAreaTargetsCollection,
  getSingleAreaTargets,
  updateAreaTargets,
  addAreaTargets,
  deleteAreaTargets,
} from "../../services/settings/settings_area_target_service";
import { actionTypes } from "../action_types";

export const GetAreaTargetsCollection = (data) => (dispatch) => {
  return getAreaTargetsCollection(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionTypes.REPORTS_SETTINGS_AREA_TARGET_GET_COLLECTION,
        payload: resp.data !== null ? resp.data : [],
      });
    }
    return Promise.resolve(resp);
  });
};

export const GetSingleAreaTargets = (data) => (dispatch) => {
  return getSingleAreaTargets(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionTypes.REPORTS_SETTINGS_AREA_TARGET_GET_SINGLE,
        payload: resp.data !== null ? resp.data : [],
      });
    }
    return Promise.resolve(resp);
  });
};

export const AddAreaTargets = (data) => (dispatch) => {
  return addAreaTargets(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionTypes.REPORTS_SETTINGS_AREA_TARGET_ADD,
        payload: resp.data !== null ? resp.data : [],
      });
    }
    return Promise.resolve(resp);
  });
};

export const UpdateAreaTargets = (data) => (dispatch) => {
  return updateAreaTargets(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionTypes.REPORTS_SETTINGS_AREA_TARGET_UPDATE,
        payload: resp.data !== null ? resp.data : [],
      });
    }
    return Promise.resolve(resp);
  });
};

export const DeleteAreaTargets = (data) => (dispatch) => {
  return deleteAreaTargets(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionTypes.REPORTS_SETTINGS_AREA_TARGET_DELETE,
        payload: resp.data !== null ? resp.data : [],
      });
    }
    return Promise.resolve(resp);
  });
};
